import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router } from '@angular/router';

import { CapabilitiesService } from '../shared/shared-context/capabilities.service';
import { BaseRouteGuard } from './base.route-guard';

@Injectable({
    providedIn: 'root'
})
export class CreateRouteGuard extends BaseRouteGuard implements CanActivate, CanLoad {

    private readonly createCenterEnabled: boolean;
    constructor(
        capabilitiesService: CapabilitiesService,
        router: Router
    ) {
        super(router, capabilitiesService);
        this.createCenterEnabled = this.capabilitiesService.capabilities.createCenterEnabled;
    }

    public canActivate() {
        return this.checkEnabledAndRedirect(this.createCenterEnabled);
    }

    public canLoad() {
        return this.checkEnabledAndRedirect(this.createCenterEnabled);
    }
}
